import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { InternalOrderEnums } from 'src/app/enum/internal-order-enums';
import { ClassMaintenanceOrderEnum } from 'src/app/enum/maintenance-order-enum';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ArticlesTypesTableModel } from 'src/app/models/archive/articles-types-table.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { InternalOrderDetailCaptureTableModel } from 'src/app/models/shopping/Internal-order-detail-capture-table.model';
import { InternalOrderDetailModel } from 'src/app/models/shopping/internal-order-detail.model';
import { InternalOrderModel } from 'src/app/models/shopping/internal-order.model';
import { ArticleService } from 'src/app/services/archive/article.service';
import { InternalOrderDetailService } from 'src/app/services/shopping/internal-order-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';
import { InternalOrderFromQuotationComponent } from '../../internal-order-from-quotation/internal-order-from-quotation.component';

@Component({
  selector: 'app-internal-order-detail',
  templateUrl: './internal-order-detail.component.html',
  styleUrls: ['./internal-order-detail.component.scss'],
  standalone: false
})
export class InternalOrderDetailComponent implements OnInit {

  @Input() internalOrderModel: InternalOrderModel = new InternalOrderModel();
  @Input() quantityDetails: number = 0;
  @Input() disabledDetail: boolean = false;
  @Input() disabledActions: boolean = false;
  @Input() swQuotation: boolean = false;
  @Output() emitQuantityDetails = new EventEmitter<number>();

  ascendant: boolean = true;
  columnSort: string | null = null;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  detailData: PagedResponseModel<InternalOrderDetailCaptureTableModel> = new PagedResponseModel<InternalOrderDetailCaptureTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  disabledButton: boolean = true;
  isFormView: boolean = false;
  limit: number = 10;
  page: number = 1;
  internalOrderDetail: InternalOrderDetailModel = new InternalOrderDetailModel();
  tableActions: TableAction[] = [];

  newArticlesDetail: number[] = [];

  component = CustomTableSelectComponent;
  inputsForArticlesByTypes$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
    actions: []
  })
  output$ = new Subject<any>();

  dataArticle: PagedResponseModel<ArticlesTypesTableModel> = new PagedResponseModel<ArticlesTypesTableModel>();
  headerArticle: ColumnResponseModel[] = [];
  ascendantArticle: boolean = true;
  columnSortArticle: string | null = null;
  filtersArticle: ColumnResponseModel[] = []
  limitArticle: number = 5;
  pageArticle: number = 1;
  subscription: Subscription;

  @ViewChild('articleType') articleTypeModalComponent?: CustomModalComponent | null = null;
  @ViewChild('quotationModal') quotationModalComponent?: CustomModalComponent | null = null;

  componentFromQuotation = InternalOrderFromQuotationComponent;
  inputsForQuotationModal$ = new BehaviorSubject<any>({ internalOrderModel: new InternalOrderModel() });

  constructor(private internalOrderDetailService: InternalOrderDetailService,
    private articleService: ArticleService,
    private toastHandlerService: ToastHandlerService) {
  }

  async ngOnInit(): Promise<void> {
    await this.getColumns();
    this.tableActions = this.getDefaultActions();

    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticle(payload);
          break;
        case 'onFilterChange':
          this.onFilterChange(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const internalOrderModel = changes["internalOrderModel"];
    if (internalOrderModel && !internalOrderModel.firstChange) {
      this.getFormView(false);
      this.getInternalOrderDetailsByInternalOrder();
      this.internalOrderDetail = new InternalOrderDetailModel();
      this.disabledButton = this.internalOrderModel.internalOrderId === 0 || this.internalOrderModel.internalOrderState !== InternalOrderEnums.open ? true : false;
    }

    const disabledActions = changes["disabledActions"];
    if (disabledActions && !disabledActions.firstChange) {
      this.tableActions = this.disabledActions ? [] : this.getDefaultActions();
    }
  }


  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }


  async clicDetail() {
    if (this.internalOrderModel.internalOrderId != 0) {
      document.getElementById("btn-select-detail")?.click();
    } else {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear el encabezado del detalle.'
      );
    }
  }

  async deleteInternalOrderDetail(selectedIds: number[]) {
    if (selectedIds.length === 0) return;

    const result = await Swal.fire({
      title: 'Atención',
      text: "¿Realmente desea eliminar el detalle del pedido interno?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.internalOrderDetailService.deleteDetails(selectedIds));
        this.toastHandlerService.showToast(
          'success',
          'El detalle del pedido interno fue eliminado exitosamente.'
        );
        this.clearSelectionTrigger++;
        this.getUpdateListDetailByDelete();
      } catch (error) {
        console.error('Error al eliminar el detalle del pedido interno.', error);
      }
    }
  }
  async getColumns() {
    try {
      this.detailHeader = await firstValueFrom(this.internalOrderDetailService.getColumnsForDetailCapture());
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getInternalOrderDetailsByInternalOrder() {
    try {
      this.detailData = await firstValueFrom(this.internalOrderDetailService.getInternalOrderDetailsByInternalOrder(this.page, this.limit, this.columnSort, this.ascendant,
        this.internalOrderModel.internalOrderId));
      this.emitQuantityDetails.emit(this.detailData.totalItems);
    } catch (error) {
      console.error('Error al buscar los detalles del pedidos internos.', error);
    }
  }

  getDefaultActions(): TableAction[] {
    return [
      {
        label: 'Editar',
        icon: 'pi pi-pencil',
        action: 'edit'
      }
    ];
  }

  getUpdateListDetailByDelete() {
    this.internalOrderDetail = new InternalOrderDetailModel();
    this.clearSelectionTrigger++;
    this.getInternalOrderDetailsByInternalOrder();
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async onAction(event: { action: string, item?: InternalOrderDetailModel, selectedItems?: number[] }) {
    if (event.action === 'edit') {
      const response = await firstValueFrom(this.internalOrderDetailService.getInternalOrderDetailById(event.item!.internalOrderDetailId));
      if (response)
        this.internalOrderDetail = response;
      this.getFormView(true);
    }
    if (event.action === 'bulk-delete' && event.selectedItems) {
      this.deleteInternalOrderDetail(event.selectedItems);
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getInternalOrderDetailsByInternalOrder();
  }

  async handleSelectedItems(selectedItems: any) {
    this.newArticlesDetail = selectedItems.map((item: any) => parseInt(item.articleId));
  }

  updateInputs() {
    this.inputsForArticlesByTypes$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: true,
      limitPaginator: true,
      filters: this.filtersArticle,
      actions: [
        {
          label: 'Imágenes',
          icon: 'pi pi-image',
          action: 'view-image'
        }
      ]
    });
  }

  async getColumnsArticle() {
    try {
      if (this.headerArticle.length === 0) {
        this.headerArticle = await firstValueFrom(this.articleService.getColumnsForArticlesByTypes());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getAllArticlesByTypes() {
    try {
      this.dataArticle = await firstValueFrom(
        this.articleService.getArticlesForInternalOrder(this.internalOrderModel.internalOrderId, this.pageArticle, this.limitArticle, this.columnSortArticle, this.ascendantArticle, this.filtersArticle)
      );
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los insumos', error);
    }
  }

  async onPageChangeArticle(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    this.getAllArticlesByTypes();
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  openQuotationModal() {
    if (this.internalOrderModel.maintenanceOrder?.maintenanceOrderClassId !== ClassMaintenanceOrderEnum.enSitio) {
      this.toastHandlerService.showToast(
        'info',
        'Para agregar artículos cotizados,asocie y guarde en el pedido interno una orden de mantenimiento de clase “EN SITIO”.'
      );
      return;
    }
    this.inputsForQuotationModal$.next({ internalOrderModel: this.internalOrderModel });
    this.quotationModalComponent?.show();
  }

  reloadFromQuotation(event: any) {
    if (event?.reloadDetail) this.getInternalOrderDetailsByInternalOrder();
  }

  async openModal() {
    this.filtersArticle = [];
    await Promise.all([
      this.getColumnsArticle(),
      this.getAllArticlesByTypes()]
    );
    this.updateInputs();
    this.articleTypeModalComponent && this.articleTypeModalComponent.show();
  }
}
